import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../Assets/logo.png";
import { getUSERSet } from "../Components/API/UserinfoAPI";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const SignIn = () => {
  const navigate = useNavigate();
  const [signinData, setSigninData] = useState({ email: "", password: "" });
  const [validEmail, setvalidEmail] = useState("");
  const [validPassword, setvalidPassword] = useState("");
  const [show, setShow] = useState(false);

  const handleChange = (e) => {
    setSigninData({ ...signinData, [e.target.name]: e.target.value });
  };

  const singIpUser = async () => {
    const { email, password } = signinData;
    try {
      if (!validation()) {
        let DataSet = await Auth.signIn(email, password);
        localStorage.setItem("email", email);
        localStorage.setItem("user", DataSet.username);
        console.log("DataSet", DataSet);
        const userData = await getUSERSet(DataSet.username);
        console.log("userData", userData);
        localStorage.setItem("client_id", userData.client_id);
        navigate("/dashboard");
      }
    } catch (error) {
      console.log(error, 'error')
      toast.error(error.message, { autoClose: 5000 });
    }
  };

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const validation = () => {
    const { email, password } = signinData;
    let valid = false;
    if (email === "") {
      setvalidEmail("Email is required");
      valid = true;
    }
    if (password === "") {
      setvalidPassword("Password is required");
      valid = true;
    }
    return valid;
  };

  return (
    <div>
      <div className="h-screen w-full flex justify-center items-center p-[20px]">
        <div className="flex max-w-[500px] mx-auto gap-10 flex-col w-full">
          <div>
            <img src={logo} className="w-[200px]" alt="logo" />
          </div>
          <div className="rounded-lg w-full shadow-[0px_0px_11px_0px_rgba(0,0,0,0.25)] bg-white sm:p-[50px] p-[20px]">
            <h3 className="text-gray-700 font-semibold sm:text-[20px] text-[18px]">
              Sign in to your account
            </h3>
            <div className="mt-5">
              <div className="flex flex-col gap-2">
                <label className="font-medium text-sm text-gray-700">
                  Email
                </label>
                <input
                  name="email"
                  onChange={(e) => handleChange(e)}
                  type="text"
                  className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                />
                <p className="text-red-600">
                  {signinData.email === "" ? validEmail : ""}
                  {signinData.email !== "" && !isValidEmail(signinData.email)
                    ? "Email is incorrect"
                    : ""}
                </p>
              </div>
              <div className="flex flex-col gap-2 mt-7">
                <div className="flex justify-between">
                  <label className="font-medium text-sm text-gray-700">
                    Password
                  </label>
                  <label
                    className="font-medium text-sm text-[#5851ff] cursor-pointer"
                    onClick={() => navigate("/resetPassword")}
                  >
                    Forgot Your Password?
                  </label>
                </div>
                <div className="w-full relative">
                  <input
                    name="password"
                    onChange={(e) => handleChange(e)}
                    type={show ? "text" : "password"}
                    className="border-[1px] border-gray-300 focus:outline-none w-full text-gray-600 px-[10px] py-[7px] rounded-md"
                  />
                  <button
                    className="absolute top-[50%] translate-y-[-50%] right-3"
                    onClick={() => setShow(!show)}
                  >
                    {show ? (
                      <AiOutlineEyeInvisible className="text-[20px] text-[#414552]" />
                    ) : (
                      <AiOutlineEye className="text-[20px] text-[#414552]" />
                    )}
                  </button>
                </div>
                <p className="text-red-600">
                  {signinData.password === "" ? validPassword : ""}
                </p>
              </div>
            </div>
            <div className="my-7">
              <div className="relative flex items-center">
                <div className="flex items-center">
                  <input
                    id="comments"
                    aria-describedby="comments-description"
                    name="comments"
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 accent-indigo-600"
                  />
                </div>
                <div className="ml-3 text-sm">
                  <label
                    htmlFor="comments"
                    className="font-medium select-none text-gray-700"
                  >
                    Stay signed in for a week
                  </label>
                </div>
              </div>
            </div>
            <div>
              <button
                onClick={() => singIpUser()}
                className="text-center px-3 sm:py-3 py-2 rounded-md bg-[#5851ff] w-full text-sm font-medium text-white"
              >
                Continue
              </button>
            </div>
            <div className="flex justify-center items-center gap-1">
              <button className="font-medium text-sm text-gray-700">
                Don't have an account?
              </button>
              <button
                className="font-medium text-sm text-[#5851ff] cursor-pointer"
                onClick={() => navigate("/signUp")}
              >
                Sign up
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
